export default {
  SET_DIALOG_IMAGE: (state, value) => {
    state.dialogImage = value
  },

  SET_DIALOG: (state, value) => {
    state.dialog = value
  },
}
